export const pt_BR = {
  translation: {
    // Toast
    toast_error_title: 'Houve um problema',
    unable_to_fetch_address:
      'Não encontramos um endereço associado a este CEP. Informe o endereço manualmente.',
    unable_to_fetch_plate:
      'Não foi possível encontrar as informações referentes a esta placa. Informe o modelo e o tipo do veículo manualmente.',
    email_or_password_invalid:
      'Não encontramos uma conta associada a este endereço de e-mail e senha',
    email_already_exists: 'Este nome de usuário já está em uso. Tente outro.',
    file_too_large: 'O tamanho máximo de arquivo suportado pela ParkOff é 5MB',
    file_invalid_type:
      'A extensão de arquivo suportado pela ParkOff é PNG, JPG e PDF',
    required_business_license:
      'Não encontramos um arquivo de alvará de funcionamento. Faça o upload e tente novamente.',
    required_file_upload:
      'Obrigatório informar um arquivo com extensão PNG, JPG e PDF ao realizar o upload para ParkOff',
    required_key_delete_file:
      'Obrigatório informar o nome do arquivo a ser excluído',
    internal_server_error:
      'Erro interno no servidor! por favor, aguarde alguns instantes e tente novamente.',
    default_error_message:
      'A ParkOff lamenta, mas aconteceu um erro inesperado',
    parking_created_title: 'Estacionamento cadastrado com sucesso',
    parking_created_success:
      'Os dados de seu estacionamento irá passar por uma validação. Em breve entraremos em contato!',
    forgot_password: 'Você receberá um e-mail com as instruções',
    rating_delete_description: 'Avaliação excluída com sucesso!',
    monthly_delete_description: 'Mensalista excluído com sucesso!',
    accredited_delete_description: 'Credenciado excluído com sucesso!',
    refused_booking_title: 'Reserva recusada com sucesso',
    refused_booking: 'O cliente será notificado da recusa e o motivo',
    reset_password_title: 'Senha alterada com sucesso',
    reset_password:
      'Você pode entrar novamente na plataforma ParkOff com sua nova senha.',
    token_expired:
      'Token inválido. Verifique se seu token está correto e tente novamente.',
    customer_not_found:
      'Não encontramos uma conta associada a este endereço de e-mail',
    parking_updated: 'Estacionamento atualizado com sucesso!',
    parking_not_found:
      'Não encontramos um estacionamento vinculado a este usuário.',
    parking_is_pending:
      'Seu estacionamento ainda está pendente de validação. Aguarde em breve entraremos em contato!',
    parking_is_disabled:
      'Seu acesso foi bloqueado pela ParkOff, entre em contato para mais informações!',
    parking_is_refused:
      'Seu acesso não foi liberado pela ParkOff, entre em contato para mais informações',
    coupoun_created_title: 'Cupom cadastrado com sucesso',
    coupoun_created_success:
      'Para utilização do cupom no aplicativo informar o "Código de cupom" cadastrado. Repasse ao seus clientes!',
    cupom_already_exist: 'Já existe um cupom cadastrado com esse código!',
    address_already_exist:
      'Já existe um estacionamento cadastrado com esse endereço!',
    monthly_already_exists_parking:
      'Mensalista já cadastrado com esse CPF/CNPJ!',
    accredited_already_exists_parking:
      'Credenciado já cadastrado com esse CPF!',
    monthly_without_space: 'Mensalista sem espaço!',
    courtyard_without_space_monthly:
      'Mensalista sem espaço, escolha uma das opções para seguir!',

    // Fields
    open_24_hours: 'Aberto 24 horas',
    indoor_parking: 'Estacionamento coberto',
    valet_parking: 'Manobrista',
    vacant_bike: 'Tem vaga para bike',
    electric_car_charging: 'Recarga carro elétrico',
    accessibility: 'Acessibilidade',
    safe: 'Seguro',
    security_camera: 'Câmera de segurança',
    on_site_agreements: 'Convênios no local',
    need_to_leave_key: 'Necessário deixar chave',
    parkoff_pass: 'ParkOff Pass',

    car_wash: 'Lavagem de veículo',
    oil_change: 'Troca de óleo',
    tire_calibration: 'Calibragem dos pneus',
    palette_exchange: 'Troca de paleta dianteira e traseira',
    upholstery_washing: 'Lavagem de estofados',
    polishing: 'Polimento',

    PENDING: 'Aguardando aprovação',
    REFUSED: 'Recusado',
    DISABLED: 'Desativado',
    ACTIVE: 'Aprovado',

    ACCEPTED: 'Aceito',
    CANCELLED: 'Cancelado',
    INPROGRESS: 'Em andamento',
    FINISHED: 'Finalizado',

    CREDIT_CARD: 'Cartão de crédito',
    DEBIT_CARD: 'Cartão de debito',
    APP: 'App',
    MONEY: 'Dinheiro',
    PIX: 'Pix',
    NONSTOP: 'Sem Parar',
    CONNECT_CAR: 'Connect car',

    MONDAY: 'Segunda',
    TUESDAY: 'Terça',
    WEDNESDAY: 'Quarta',
    THURSDAY: 'Quinta',
    FRIDAY: 'Sexta',
    SATURDAY: 'Sábado',
    SUNDAY: 'Domingo',

    CAR: 'Carro',
    MOTORCYCLE: 'Moto',
    BIKE: 'Bicicleta',

    // Zod
    empty_email: 'Digite seu e-mail',
    enter_password: 'Digite uma senha',
    empty_name: 'Digite um nome para o estacionamento',
    empty_name_2: 'Digite um nome',
    empty_cnpj: 'Digite um CNPJ',
    empty_cpf: 'Digite um CPF',
    empty_cpf_cnpj: 'Digite um CPF ou CNPJ',
    empty_phone: 'Digite um telefone ou celular',
    empty_legal_representative: 'Digite um nome para o representante legal',
    empty_zipcode: 'Digite um CEP',
    empty_street: 'Digite um endereço',
    empty_number: 'Digite um número',
    empty_state: 'Digite um estado',
    empty_country: 'Digite um país',
    empty_city: 'Digite uma cidade',
    empty_parking_space: 'Digite o número total de vagas',
    empty_price: 'Digite o preço',
    empty_neighborhood: 'Digite um bairro',
    empty_latitude: 'Digite uma latitude',
    empty_longitude: 'Digite uma longitude',
    empty_tag: 'Digite um código de cupom',
    empty_value_discount: 'Digite o valor do desconto',
    empty_parking: 'Digite um estacionamento',
    empty_start_hours: 'Digite um horário de entrada',
    empty_end_hours: 'Digite um horário de saída',
    empty_maturity_fee: 'Digite o valor do juros',
    empty_due_date: 'Digite dia de vencimento',
    empty_select: 'Selecione uma opção',
    empty_date: 'Selecione uma data',
    empty_days: 'Selecione pelo menos 1 dia',
    empty_vehicle_model: 'Digite um modelo',
    empty_vehicle_license_plate: 'Digite a placa',
    empty_vehicle_collor: 'Digite uma cor',

    // Invalid
    invalid_email: 'Digite um e-mail válido',
    invalid_parking: 'Digite um estacionamento válido',
    password_eight_characters: 'Use 8 caracteres ou mais para sua senha',
    password_dont_match: 'As senhas não são iguais',
  },
}
